import styled from 'styled-components';

export const Tile = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TileFooter = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? 'rgba(230,231,238,0.66)'};
`;
